import React from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import block from 'bem-cn'

import { MODAL_ROUTE_PATH } from 'router/modalRoutes'

import { getRouteParamsByStrings } from 'shared/utils/getRouteParamsByStrings'

import { useResetPasswordConfirm } from 'modules/Emails/hooks'

import { selectLocaleDict } from 'features/locale/selectors'

import { useModalContext } from '@bcraft-frontend-lib/core'

import { ModalWrapper } from 'components/ModalWrapper'
import { ButtonSizes, Form, FormInput } from 'components/UIKit'
import Button from 'components/UIKit/Button/Button'

import './ResetPasswordConfirmModal.scss'

export type ResetPasswordConfirmModalProps = {
  path: string
}

type ResetPasswordConfirmModalParams = {
  token: string
}

const b = block('reset-password-confirm-modal')

export const ResetPasswordConfirmModal: React.FC<ResetPasswordConfirmModalProps> = ({ path }) => {
  const params = getRouteParamsByStrings<ResetPasswordConfirmModalParams>(MODAL_ROUTE_PATH.RESET_PASSWORD_CONFIRM, path)
  const { closeModal } = useModalContext()

  const onClose = () => {
    closeModal(path)()
  }

  const { isLoading, formik } = useResetPasswordConfirm({ token: params?.token, onSuccess: onClose })

  const locale = useSelector(selectLocaleDict, shallowEqual).profile

  return (
    <ModalWrapper title={locale.changePassword} className={b()} onClose={onClose}>
      <Form formik={formik} className={b('form')}>
        <FormInput
          type="password"
          name="newPassword"
          placeholder={locale.newPassword}
          caption={locale.newPassword}
          canBeHidden
        />

        <FormInput
          type="password"
          name="repeatNewPassword"
          placeholder={locale.repeatNewPassword}
          caption={locale.repeatNewPassword}
          canBeHidden
        />

        <Button type="submit" text={locale.save} loading={isLoading} fullWidth size={ButtonSizes.LARGE} />
      </Form>
    </ModalWrapper>
  )
}
